import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SAVEIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10 5.333H5.733c-.373 0-.56 0-.702-.072a.67.67 0 0 1-.292-.292c-.072-.142-.072-.329-.072-.702V2m6.666 12V9.733c0-.373 0-.56-.072-.702a.67.67 0 0 0-.292-.292c-.142-.072-.329-.072-.702-.072H5.733c-.373 0-.56 0-.702.072a.67.67 0 0 0-.292.292c-.072.142-.072.329-.072.702V14M14 6.217V10.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C12.48 14 11.92 14 10.8 14H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 12.48 2 11.92 2 10.8V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 2 4.08 2 5.2 2h4.583c.326 0 .49 0 .643.037q.205.05.385.16c.135.082.25.197.48.428l2.084 2.084c.23.23.346.345.428.48q.11.181.16.385c.037.154.037.317.037.643" /></svg>
  );
}

export default SAVEIcon;
